import { type ApmBase, init as apmInit } from '@elastic/apm-rum';
import getConfig from 'next/config';
import {
  apmRumIdPlaceholders,
  apmRumRemoveIgnored,
  ignoredPatterns,
} from 'utils/apm-utils';

const createApmRum = (): ApmBase | undefined => {
  const { publicRuntimeConfig } = getConfig();

  if (
    typeof window !== 'undefined' &&
    publicRuntimeConfig &&
    publicRuntimeConfig.apmServerUrl
  ) {
    /**
     * Total sample rate is combination of two options: active and transactionSampleRate.
     * Total rate = apmSampleRate * apmSampleRate (for example 0.1 * 0.1 = 0.01)
     */

    const apmSampleRate = Number(publicRuntimeConfig.apmSampleRate) || 1;

    const apm = apmInit({
      serviceName: 'areena-web-items',
      active: Math.random() < apmSampleRate,
      serverUrl: publicRuntimeConfig.apmServerUrl,
      environment: publicRuntimeConfig.environment || '',
      serviceVersion: publicRuntimeConfig.versionNumber || '',
      transactionSampleRate: apmSampleRate,
      distributedTracingOrigins: [
        'https://areena.api-test.yle.fi',
        'https://areena.api.yle.fi',
        'https://player.api-test.yle.fi',
        'https://player.api.yle.fi',
      ],
      ignoreTransactions: ignoredPatterns,
    });
    apm.addFilter(apmRumRemoveIgnored);
    apm.addFilter(apmRumIdPlaceholders);
    return apm;
  }
};

export function init(): void {
  apmRum = createApmRum();
}

export let apmRum: ApmBase | undefined;
